(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      root.querySelectorAll('[data-glass-video]').forEach((section) => {
        if (section.dataset.videoInitialized) return;
        section.dataset.videoInitialized = 'true';
        const video = section.querySelector('video');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const desktop = window.matchMedia('(min-width: 750px)');
        const controller = new AbortController();
        const options = { signal: controller.signal };
        const connection = navigator.connection;
        const bounds = section.getBoundingClientRect();
        let inView = bounds.bottom > 0 && bounds.top < window.innerHeight;
        let wantsToPlay = !reduceMotion.matches && !connection?.saveData && !['slow-2g', '2g'].includes(connection?.effectiveType);
        let generation = 0;
        let loaded = false;
        let startupReady = false;
        let startupTimer;
        let stallTimer;
        let preferSmallerVideo = false;
        let preparing = false;
        let webmFailed = false;
        let capability;
        let gestureArmed = false;
        // Some browsers (iOS Low Power Mode) refuse muted autoplay; the video then
        // starts on the visitor's first tap, scroll or key press anywhere on the page.
        const playOnFirstGesture = () => {
          if (gestureArmed) return;
          gestureArmed = true;
          const retry = () => {
            if (!gestureArmed) return;
            gestureArmed = false;
            startupReady = true;
            syncPlayback();
          };
          ['pointerdown', 'touchend', 'keydown', 'scroll'].forEach((type) =>
            window.addEventListener(type, retry, { once: true, passive: true, signal: controller.signal }));
        };
        const fallbackSource = () => desktop.matches && video.dataset.desktopVideoUrl ? video.dataset.desktopVideoUrl : video.dataset.videoUrl;
        const efficientDesktop = () => {
          if (!capability) {
            capability = navigator.mediaCapabilities?.decodingInfo({
              type: 'file',
              video: { contentType: 'video/webm; codecs="av01.0.12M.08"', width: 2560, height: 1440, bitrate: 4000000, framerate: 30 }
            }).then((result) => result.supported && result.smooth && result.powerEfficient).catch(() => false) || Promise.resolve(false);
          }
          return capability;
        };
        const smallerSource = () => desktop.matches ? video.dataset.desktopLowVideoUrl : video.dataset.mobileLowVideoUrl;
        const sourceChoice = async () => {
          const limitedConnection = connection?.saveData || ['slow-2g', '2g', '3g'].includes(connection?.effectiveType) || (connection?.downlink > 0 && connection.downlink < 4.5);
          // Phones start on the lite encode. When the full one can't buffer in 4 s
          // the fallback downloads the lite one ON TOP of it (~2.9 MB instead of
          // ~1.2 MB), and iOS has no Network Information to warn us in advance.
          // Only a connection that reports itself fast gets the full mobile encode.
          const fastConnection = connection?.effectiveType === '4g' && connection?.downlink >= 10;
          const phoneDefault = !desktop.matches && !fastConnection;
          if (smallerSource() && (preferSmallerVideo || limitedConnection || phoneDefault)) return smallerSource();
          if (desktop.matches && video.dataset.desktopWebmUrl && !webmFailed && connection?.effectiveType !== '2g' && connection?.effectiveType !== 'slow-2g') {
            const efficient = await Promise.race([efficientDesktop(), new Promise((resolve) => setTimeout(() => resolve(false), 250))]);
            if (efficient) return video.dataset.desktopWebmUrl;
          }
          return fallbackSource();
        };
        const play = () => {
          if (!loaded || preparing || !video.paused) return;
          if (!startupReady) {
            const ahead = video.buffered.length ? video.buffered.end(video.buffered.length - 1) - video.currentTime : 0;
            if (ahead < Math.min(2, video.duration || 2)) return;
            startupReady = true;
          }
          video.muted = true;
          video.play().catch((error) => {
            if (error.name === 'NotAllowedError') playOnFirstGesture();
          });
        };
        const syncPlayback = () => {
          if (wantsToPlay && inView && !document.hidden) play();
          else {
            clearTimeout(stallTimer);
            video.pause();
          }
        };
        const useSmallerVideo = () => {
          if (!wantsToPlay || !inView || document.hidden) return;
          const smaller = smallerSource();
          if (smaller && video.getAttribute('src') !== smaller) {
            preferSmallerVideo = true;
            prepareSource();
          }
        };
        const prepareSource = async () => {
          if (!wantsToPlay) return;
          const current = ++generation;
          preparing = true;
          const source = await sourceChoice();
          if (controller.signal.aborted || current !== generation) return;
          preparing = false;
          if (!loaded || video.getAttribute('src') !== source) {
            const time = loaded && Number.isFinite(video.currentTime) ? video.currentTime : 0;
            video.pause();
            video.classList.remove('is-playing');
            video.preload = 'auto';
            startupReady = false;
            clearTimeout(startupTimer);
            clearTimeout(stallTimer);
            // Never force playback before the buffer is ready. A slow first load
            // gets a smaller source, including browsers without Network Information.
            startupTimer = setTimeout(useSmallerVideo, 4000);
            video.addEventListener('loadedmetadata', () => {
              if (current === generation && time && Number.isFinite(video.duration)) video.currentTime = time % video.duration;
            }, { once: true, signal: controller.signal });
            video.src = source;
            loaded = true;
            video.load();
          }
          syncPlayback();
        };
        const reveal = () => {
          if (video.readyState >= 2) video.classList.add('is-playing');
        };
        video.addEventListener('progress', syncPlayback, options);
        video.addEventListener('canplay', syncPlayback, options);
        video.addEventListener('waiting', () => {
          clearTimeout(stallTimer);
          // A loop seek may emit waiting; only downgrade for a sustained mid-loop stall.
          if (video.currentTime > .2 && video.currentTime < video.duration - .2) {
            stallTimer = setTimeout(useSmallerVideo, 1500);
          }
        }, options);
        video.addEventListener('playing', () => {
          clearTimeout(stallTimer);
          startupReady = true;
          clearTimeout(startupTimer);
          if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(reveal);
          else reveal();
        }, options);
        video.addEventListener('error', () => {
          if (!webmFailed && video.getAttribute('src') === video.dataset.desktopWebmUrl) {
            webmFailed = true;
            prepareSource();
          } else {
            video.classList.remove('is-playing');
          }
        }, options);
        const music = section.querySelector('.rich-text__music-toggle');
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (music && AudioContextClass) {
          // Off until asked for. The file loads on the first press and loops
          // sample-accurately through Web Audio; <audio loop> leaves a gap.
          const volume = .8;
          let context;
          let gain;
          let buffer;
          let source;
          let fading;
          let loading = false;
          let on = false;
          let musicInView = inView;
          const setMusicState = (playing) => {
            on = playing;
            music.setAttribute('aria-pressed', String(playing));
            music.setAttribute('aria-label', playing ? music.dataset.pauseLabel : music.dataset.playLabel);
          };
          const fadeTo = (value, seconds) => {
            const now = context.currentTime;
            gain.gain.cancelScheduledValues(now);
            gain.gain.setValueAtTime(gain.gain.value, now);
            gain.gain.linearRampToValueAtTime(value, now + seconds);
          };
          const stopSource = (node, when) => {
            try { node?.stop(when); } catch (error) { /* already stopped */ }
          };
          const startMusic = () => {
            stopSource(fading);
            fading = null;
            source = context.createBufferSource();
            source.buffer = buffer;
            source.loop = true;
            source.loopStart = Number(music.dataset.loopStart);
            source.loopEnd = Number(music.dataset.loopEnd);
            source.connect(gain);
            // Start where the animation is, so each phrase lands on the video loop.
            const cycle = Number.isFinite(video.duration) && video.duration > 0 ? video.duration : 12;
            source.start(0, source.loopStart + (video.paused ? 0 : video.currentTime % cycle));
            fadeTo(volume, 1.2);
          };
          const stopMusic = () => {
            fading = source;
            source = null;
            fadeTo(0, .6);
            stopSource(fading, context.currentTime + .65);
          };
          const syncMusic = () => {
            if (!context || !on || !source) return;
            if (musicInView && !document.hidden) {
              context.resume();
              fadeTo(volume, .8);
            } else if (document.hidden) {
              context.suspend();
            } else {
              // Scrolled away: the button is out of reach, so the music rests too.
              fadeTo(0, .5);
              setTimeout(() => { if (!musicInView && on) context.suspend(); }, 550);
            }
          };
          music.hidden = false;
          music.addEventListener('click', async () => {
            if (on) {
              setMusicState(false);
              stopMusic();
              return;
            }
            setMusicState(true);
            // iOS mutes Web Audio with the ringer switch unless it is declared as playback.
            if (navigator.audioSession) navigator.audioSession.type = 'playback';
            if (!context) {
              context = new AudioContextClass();
              gain = context.createGain();
              gain.gain.value = 0;
              gain.connect(context.destination);
            }
            const resumed = context.resume();
            if (!buffer) {
              if (loading) return;
              loading = true;
              music.dataset.loading = '';
              try {
                const response = await fetch(music.dataset.musicUrl);
                if (!response.ok) throw new Error(response.status);
                buffer = await context.decodeAudioData(await response.arrayBuffer());
              } catch (error) {
                setMusicState(false);
                return;
              } finally {
                loading = false;
                delete music.dataset.loading;
              }
            }
            await resumed;
            if (on && !source) startMusic();
          }, options);
          const musicObserver = new IntersectionObserver((entries) => {
            musicInView = entries[0].isIntersecting;
            syncMusic();
          }, { threshold: .01 });
          musicObserver.observe(section);
          document.addEventListener('visibilitychange', syncMusic, options);
          controller.signal.addEventListener('abort', () => {
            musicObserver.disconnect();
            context?.close();
          });
        }
        desktop.addEventListener('change', prepareSource, options);
        reduceMotion.addEventListener('change', () => {
          wantsToPlay = !reduceMotion.matches && !connection?.saveData && !['slow-2g', '2g'].includes(connection?.effectiveType);
          if (wantsToPlay) prepareSource();
          else syncPlayback();
        }, options);
        document.addEventListener('visibilitychange', syncPlayback, options);
        window.addEventListener('pageshow', syncPlayback, options);
        const observer = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          if (inView && !loaded && !preparing) prepareSource();
          else syncPlayback();
        }, { threshold: .01 });
        observer.observe(section);
        if (inView) prepareSource();
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(section)) {
            observer.disconnect();
            clearTimeout(startupTimer);
            clearTimeout(stallTimer);
            video.pause();
            controller.abort();
          }
        }, options);
      });
    };
    initialize(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
